/**
 * Resource bảng kê ghi thu ghi chi
 */
export default {
  Title: 'Bảng kê ghi thu - ghi chi',
  DateRange: 'Khoảng thời gian',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  DocumentInclude: 'Kèm theo',
  GetData: 'Lấy dữ liệu',
  Receipt: 'Kê thu',
  Expense: 'Kê chi',
  Description: 'Diễn giải',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày bảng kê',
  RefNo: 'Số bảng kê',
  RefNoTitle: 'Số bảng kê',
  SUGenerateVoucher: 'Ghi thu - Ghi chi',
  SUGenerateVoucherNSNN: 'Ghi thu vào NSNN',
  SUGenerateVoucherNSNNTooltip: 'Ghi thu vào ngân sách nhà nước',
  ViewVoucher: 'Xem thanh toán',

  AlertBeforeTransfer: {
    Title: 'Lập phiếu kết chuyển không thành công',
    Content: 'Vui lòng chọn ít nhất một dòng dữ liệu chi tiết.',

    TitleAmount: 'Không hợp lệ',
    ContentAmount: 'Số ghi thu và Số ghi chi phải bằng nhau.',
  },

  AlertBeforeTransferEmptyData: {
    Title: 'Không hợp lệ',
    Content: 'Không có chứng từ ghi thu - ghi chi nào được duyệt. Không thể thực hiện kết chuyển.',
    ContentNSNN: 'Không có chứng từ nộp tiền NSNN. Không thể thực hiện kết chuyển.',

    TitleAmount: 'Không hợp lệ',
    ContentAmount: 'Số ghi thu và Số ghi chi phải bằng nhau.',
  },

  PrintVoucher: {
    Print_1: 'Bảng kê ghi thu - ghi chi',
    Print_2: 'Giấy nộp tiền vào ngân sách nhà nước (C1-02/NS) (TT số 119/2014/TT-BTC)',
    Print_3: 'Lệnh ghi thu - ghi chi ngân sách (C2-17s/NS)(TT số 19/2020/TT-BTC)',
    Print_4: 'Lệnh ghi thu - ghi chi ngân sách (C2-17a/NS)(TT số 77/2017/TT-BTC)',
    PrintOption: 'Tùy chọn in',
  },

  AlertRefDate: {
    Title: 'Cất không thành công',
    Message: 'Ngày bảng kê không được nhỏ hơn ngày chứng từ của các chứng từ đã chọn',
    MessagePostedDate: 'Ngày bảng kê không được nhỏ hơn ngày hạch toán của các chứng từ đã chọn.',
    Button: 'Đồng ý',
  },

  Message: {
    Warning: '{0} không được phép vượt quá {1}. Vui lòng kiểm tra lại.',
  },
};
